'use client'

import type { GroundData } from '@/app/_components/ground/load-ground-data'
import { SpecimenFrame } from '@/app/_components/ground/specimen-frame'
import { standInputForGuest } from '@/app/_components/ground/stand-input'
import { PanelStand } from '@/journey/_components/panel-stand'
import { composeStand } from '@/journey/_lib/compose-stand'
import { guestSignoff } from '@/journey/_lib/guest-seams'
import { GUEST_SIGNIN_HREF } from '@/lib/auth/guest'

// Beat 06: the dashboard's center panel after Lesson 1, composed by the
// app's own composeStand and guest sign-off seam. The chrome strip is
// session-aware and is not rendered; the stand is the beat's focus.
export function StandSpecimen({
    data,
}: {
    data: Pick<GroundData, 'lesson' | 'one' | 'today'>
}) {
    const stand = composeStand(standInputForGuest(data))
    return (
        <SpecimenFrame beat={6} className="max-w-3xl">
            <div data-focus>
                <PanelStand
                    stand={{
                        ...stand,
                        primary: guestSignoff(stand.primary, true),
                    }}
                    contentsHref={GUEST_SIGNIN_HREF}
                />
            </div>
        </SpecimenFrame>
    )
}
